
<template>
<div class="cari-extre">
  <div class="overlay active" v-if="detayac"></div>

  <!-- ÜST BAR -->
  <div class="top-bar">

    <!-- 2 tarih input’u -->
    <div class="date-column">
      <input type="date" placeholder="gg.aa.yyyy" v-model="filtre.t1">
      <input type="date" placeholder="gg.aa.yyyy" v-model="filtre.t2">
    </div>

    <!-- Kırmızı Filtrele butonu -->
    <button class="btn-filter"  @click="filtrele">Filtrele</button>

    <!-- 4 adet özet kutu -->
    <div class="summary-strip">
      <div class="summary-card">
        <div class="amount">{{$helper.parabirimi(source.bakiye,'')+'TL'}}</div>
        <div class="label">Genel Bakiye</div>
      </div>
      <div class="summary-card">
        <div class="amount">{{ebakiye + 'TL' }}</div>
        <div class="label">Ekran Bakiye</div>
      </div>
      <div class="summary-card">
        <div class="amount">{{ vergi+ 'TL'}}</div>
        <div class="label">Toplam İade</div>
      </div>
      <div class="summary-card">
        <div class="amount">{{ iskonto+ 'TL'}}</div>
        <div class="label">Toplam İskonto</div>
      </div>
    </div>

    <!-- Export kutusu -->
    <div class="export-card">
      <div class="export-icon" @click="exportGenericArray(posts, $helper.trtgoster(new Date()))">📄</div> <!-- yerine Excel ikonunu koyarsın -->
      <div class="export-text" >Export</div>
    </div>

  </div>
<div class="filter-row" style="padding:10px">
  <input type="date" placeholder="gg.aa.yyyy" class="f-input" v-model="filtre.t1">
  <input type="date" placeholder="gg.aa.yyyy" class="f-input" v-model="filtre.t2">
  <button class="btn-filter" @click="filtrele">Filtrele</button>
</div> 
  <!-- TABLO -->
  <div class="table-wrapper">
    <table class="cari-table">
      <thead>
        <tr>
          <th>Tarih</th>
          <th>İşlem</th>
          <th>Tür</th>
          <th>Seri</th>
          <th>Sıra</th>
          <th>Durum</th>
          <th>Vade</th>
          <th>Vergi</th>
          <th>İskonto</th>
          <th>Borç</th>
          <th>Alacak</th>
          <th>Bakiye</th>
          <th>D</th>
          <th>F</th>
        </tr>
      </thead>
      <tbody>
        <!-- ÖRNEK SATIR 1 -->
        <tr v-for="(item,indexs) in nakli" :key="indexs">
          <td data-label="Tarih"    class="col-tarih"> {{item.tarih}}</td>
          <td data-label="İşlem"    class="col-islem">{{item.hc.substring(0, 15)}}</td>
          <td data-label="Tür"      class="col-tur"> {{item.ht}}</td>
          <!-- mobile için Seri - Sıra birleşik -->
          <td data-label="Seri - Sıra" class="col-seri" :data-mobile-value="item.seri+ '-' + item.sira">{{item.seri}}</td>
          <td data-label="Sıra"     class="col-sira">{{item.sira}}</td>
          <td data-label="Durum"    class="col-durum">{{item.durum}}</td>
          <td data-label="Vade"     class="col-vade">{{item.vade}}</td>
          <td data-label="Vergi"    class="col-vergi">{{item.vergi + ' TL'}}</td>
          <td data-label="İskonto"  class="col-iskonto"> {{item.iskonto + ' TL'}}</td>
          <td data-label="Borç"     class="td-borc"> {{item.borc + ' TL'}}</td>
          <td data-label="Alacak" class="td-alacak">{{item.alacak + ' TL'}}</td>
          <td data-label="Bakiye"   class="td-bakiye">{{item.bakiye + ' TL'}}</td>
          <td data-label="D"  class="td-icon">  </td>
          <td data-label="F" class="td-icon">  </td>
        </tr> 
        <tr v-for="(item,index) in posts" :key="index">
          <td class="col-tarih"> {{item.tarih}}</td>
          <td class="col-islem">{{item.hc.substring(0, 15)}}</td>
          <td class="col-tur"> {{item.ht}}</td>
          <!-- mobile için Seri - Sıra birleşik -->
          <td :data-mobile-value="item.seri+ '-' + item.sira">{{item.seri}}</td>
          <td class="col-sira">{{item.sira}}</td>
          <td class="col-durum">{{item.durum}}</td>
          <td class="col-vade">{{item.vade}}</td>
          <td data-label="Vergi"    class="col-vergi">{{item.vergi + ' TL'}}</td>
          <td data-label="İskonto"  class="col-iskonto"> {{item.iskonto + ' TL'}}</td>
          <td data-label="Borç"     class="td-borc"> {{item.borc + ' TL'}}</td>
          <td data-label="Alacak" class="td-alacak">{{item.alacak + ' TL'}}</td>
          <td data-label="Bakiye"   class="td-bakiye">{{item.bakiye + ' TL'}}</td>
          <td data-label="D" class="td-icon"> <i style="font-size:16px; font-weight:600" @click="modal(item.tur, item.seri, item.sira, item.tarih)" class="icon-search"></i>  </td>
          <td data-label="F" class="td-icon" style="font-size:19px; color:red"> 📄  </td>
        </tr>         
      </tbody>
    </table>
  </div>
    <foy v-if="detayac" :kalem="kalem" @close="detayac = false"/>

</div>

</template>
<script>
import foy from "@/components/foy";


export default {
  components: {
    foy,
  },
  data() {
    return {
      hesap:this.$request.ayar(),
      source: this.$store.aktifCari,
      filtre: {
        t1: new Date().getFullYear() + ".01.01",
        t2: this.$helper.trtgosternoktali(new Date()),
        ckod: this.$store.aktifCari.kod,
      },
      open: true,
      detay: [],
      nakli: [],
      vergi: 0,
      iskonto: 0,
      ebakiye: 0,
      smrkModel: "All",
      obj: {},
      arr: [],
      posts: [],
      post: [],
      error: [],
      kalem: {
        kalem: [],
        toplam: {
          aratoplam: 0,
          iskonto1: 0,
          iskonto2: 0,
          geneltoplam: 0,
          vergi: 0,
        },
        genel: {
          evrak: "",
          tarih: "",
          evrak2: "",
        },
      },
      detayac : false
    };
  },
  created() {
    this.$store.setLoading([false,'Bekleyiniz'])
    this.filtrele();
  },

  methods: {
    filtrele() {
      console.log(this.$store.aktifCari.kod)
      if (this.filtre.t1 && this.filtre.t2) {
      this.$store.setLoading([true,'Bekleyiniz'])

        this.$request.post(this.hesap.program + "/foy/", this.filtre).then(res => {
            if (res.status != 300) {
            this.ebakiye = res.toplamlar.ebakiye
            this.iskonto = res.toplamlar.iskonto
            this.vergi = res.toplamlar.vergi

            this.nakli = res.nakli
            this.posts = res.posts
            this.$store.setLoading([false,'Bekleyiniz'])
            }
            else {
            this.$store.setLoading([false,'Bekleyiniz'])
                this.$router.push("/oturum")
            }


          })
          .catch((err) => {
            //this.$swal("Birşeyler ters gitti tekrar dene" + err);
          });
      } else {
        alert("Lütfen tarih seçiniz");
      }
    },

    modal(tur, seri, sira, tarih) {
    this.$store.setLoading([true,'Bekleyiniz'])
    this.$request.post("mikro/foydetay/", {
            tur: tur,
          seri: seri,
          sira: sira,
          }).then(res => { 
            console.log(res)
          this.kalem.kalem = [];
          this.kalem.toplam.aratoplam = 0;
          this.kalem.toplam.iskonto1 = 0;
          this.kalem.toplam.iskonto2 = 0;
          this.kalem.toplam.vergi = 0;
          this.kalem.toplam.geneltoplam = 0;
          res.response.forEach((ele) => {
            this.kalem.kalem.push({
              kod: ele.sth_stok_kod,
              isim: ele.isim,
              adet: ele.sth_miktar,
              birim: ele.birim,
              birim_fiyat: ele.birim_tutar,
              isk_birim_fiyat: ele.iskontolu_birim_f,
              vergi: ele.vergi,
            });
            this.kalem.toplam.aratoplam +=ele.aratoplam,
            this.kalem.toplam.iskonto1 +=ele.iskonto1,
            this.kalem.toplam.iskonto2 += ele.iskonto2,
            this.kalem.toplam.vergi += ele.vergi*ele.sth_miktar,
            this.kalem.toplam.geneltoplam +=ele.iskontolu_tutar + ele.vergi,
            this.kalem.genel.evrak2 =
              ele.sth_evrakno_seri + " " + ele.sth_evrakno_sira;
          });
          this.kalem.genel.evrak = seri + " " + sira;
          this.kalem.genel.tarih = tarih;
    this.$store.setLoading([false,'Bekleyiniz'])
          this.detayac = true
        });
        
    },
    close(){
      this.detayac=false
    },
exportGenericArray (dataArray, fileName = 'export') {
    if (!Array.isArray(dataArray) || !dataArray.length) return;

    // İlk objenin key’lerine göre başlık
    const keys = Object.keys(dataArray[0]);

    const lines = [];
    lines.push(keys.join(';')); // header

    dataArray.forEach(row => {
      const line = keys.map(k => {
        let val = row[k];

        if (val === null || val === undefined) val = '';
        else if (typeof val === 'object') val = JSON.stringify(val);

        // ; ve line break temizle
        return String(val).replace(/;/g, ',').replace(/\r?\n/g, ' ');
      }).join(';');

      lines.push(line);
    });

    const csvContent = '\uFEFF' + lines.join('\r\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }    
  },
};
</script>
<style scoped> 
 .cari-extre {
      width: 100%;
    }

    /* ================== ÜST BAR (PC) ================== */

    .top-bar {
      display: flex;
      flex-wrap: nowrap;
      align-items: stretch;
      gap: 8px;
      margin-bottom: 10px;
    }

    /* Soldaki iki tarih input’u */
    .date-column {
      display: flex;
      flex-direction: column;
      gap: 6px;
      width: 190px;
      min-width: 170px;
    }

    .date-column input {
      height: 36px;
      border-radius: 3px;
      border: 1px solid #ccc;
      padding: 0 8px;
      font-size: 13px;
      background-color: #fff;
    }

    /* Kırmızı filtre butonu (date column’un yüksekliği kadar) */
    .btn-filter {
      background-color: #d9303e;
      color: #fff;
      border: none;
      border-radius: 3px;
      padding: 0 26px;
      height: 78px; /* 2 input + aradaki gap’e yakın */
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      white-space: nowrap;
    }



    /* Ortadaki 4 kutu */
    .summary-strip {
      display: flex;
      flex: 1 1 auto;
      gap: 8px;
      min-width: 260px;
    }

    .summary-card {
      flex: 1 1 0;
      /* min-width: 150px; */
      background-color: #fff;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
      text-align: center;
      padding: 10px 8px;
    }

    .summary-card .amount {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 4px;
    }

    .summary-card .label {
      font-size: 13px;
    }

    /* Sağdaki Export kutusu */
    .export-card {
      width: 110px;
      min-width: 100px;
      background-color: #fff;
      border: 1px solid #f0f0f0;
      border-radius: 4px;
      text-align: center;
      padding: 10px 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 4px;
    }

    .export-icon {
      font-size: 22px;
      color: #23a047;   /* Excel yeşili */
    }

    .export-text {
      font-size: 13px;
      font-weight: 600;
    }

    /* ================== TABLO (PC) ================== */

    .table-wrapper {
      background: #fff;
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      overflow-x: auto;
    }

    .cari-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 13px;
    }

    .cari-table th,
    .cari-table td {
      border: 1px solid #d8d8d8;
      padding: 6px 8px;
      text-align: center;
      white-space: nowrap;
    }

    .cari-table thead th {
      background: #f1f2f7;
      font-weight: 700;
    }

    .td-borc   { background:#e6f7e6; }
    .td-bakiye { background:#ffe6e6; }

    .td-icon { cursor:pointer; }

    /* ================== ÜST BAR RESPONSIVE ================== */

    /* Tablet + mobil için 4 kutuyu ikili yapma, filtre+export yan yana */
    @media (max-width: 900px),
           (max-width: 1024px) and (orientation: portrait) {

      .top-bar {
        flex-wrap: wrap;
        gap: 8px;
      }

      .date-column {
        order: 1;
        width: 100%;
      }

      .summary-strip {
        order: 2;
        width: 100%;
        flex-wrap: wrap;
      } 
      .btn-filter {
        order: 3;
        flex: 1 1 50%;
        width: 100%;
        height: 60px;
        font-size: 15px;
      }

      .export-card {
        order: 3;
        flex: 1 1 50%;
        height: 60px;
      }
    }

    /* ================== TABLO: MOBİL & DİKEY TABLET ================== */

    @media (max-width: 768px),
           (max-width: 1024px) and (orientation: portrait) {
.amount {font-size:14px !important}
      /* Başlık satırını gizle */
      .cari-table thead {
        display: none;
      }
      .td-borc:before, .td-bakiye:before, .td-alacak:before, .td-icon:before {background:white !important ; border-top:2px solid #f2f2f2;border-right:1px solid #f2f2f2}
      /* Her satırı 5 kolonlu grid yap (üst 5 alan + alt 5 alan) */
      .cari-table tbody tr {
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        /* border: 1px solid #d8d8d8; */
        margin-bottom: 15px;
        background: #fff;
      }

      .cari-table tbody td {
        border: 1px solid #f2f2f2;
        padding: 4px 2px;
        font-size: 13px;          /* değer fontu biraz büyük */
        position: relative;
        text-align: center;       /* değer ortada */
        white-space: normal;
      }

      /* Her hücreye light bg’li başlık */
      .cari-table tbody td::before {
        content: attr(data-label);
        position: absolute;
        top: -7px;
        left: -1px;
        right: -1px;
        padding: 3px 2px;
        font-size: 12px;         /* label fontu */
        font-weight: 700;
        background: #f2f2f2;     /* daha light header rengi */
        border-bottom: 1px solid #d8d8d8;
      }

      .cari-table tbody td {
        padding-top: 20px;       /* label için yer aç */
      }

      /* İşlem, Vergi, İskonto, Sıra alanlarını gizle */
      .cari-table tbody td.col-islem,
      .cari-table tbody td.col-vergi,
      .cari-table tbody td.col-iskonto,
      .cari-table tbody td.col-sira {
        display: none;
      }

      /* Seri hücresinde Seri - Sıra göster (data-mobile-value) */
      .cari-table tbody td.col-seri {
        font-size: 0;            /* orijinal metni gizle */
      }

      .cari-table tbody td.col-seri::after {
        content: attr(data-mobile-value);
        display: block;
        margin-top: 3px;
        font-size: 13px;         /* gerçek değer */
        font-weight: 400;
      }

      /* Renkleri mobilde yumuşat */
      .td-borc   { background:#f4fff4; }
      .td-bakiye { background:#fff4f4; }
    }
/* PC / geniş ekran: klasik flex, nasıl istersen */
.filter-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

/* örnek PC görünümü */
.f-input {
  height: 36px;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 0 8px;
  font-size: 13px;
}

.btn-filter,
.btn-export {
  border-radius: 3px;
  padding: 0 16px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.btn-filter {
  background: #d9303e;
  color: #fff;
  border: none;
}

.btn-export {
  background: #fff;
  color: #23a047;
  border: 1px solid #23a047;
}
.filter-row {
  display: none;
}
/* MOBİL + TABLET: hepsini tek satıra al */
/* İstersen 4’e böleriz: 2 input + filtre + export */
@media (max-width: 992px) {
  .filter-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4 eşit alan */
    gap: 6px;
  }
.date-column,
  .top-bar .btn-filter,.export-card{display:none};

  .f-input,
  .btn-filter,
  .btn-export {
    width: 100%;
    padding: 6px 8px;
    font-size: 13px;
  }

  .btn-filter,
  .btn-export {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.modal-dialog {
  width: 100% !important;
  margin: 0;
  padding: 0;
}
.modal-content {
  height: auto;
  min-height: 100%;
  border-radius: 0;
}
  </style>


// WEBPACK FOOTER //
// src/views/cari/extre.vue